import React, { useState } from 'react';
import ShopifyOrderItems from './ShopifyOrderItems';
import { useEffect } from 'react';
import moment from 'moment';

const JSONAPIDeserializer = require('jsonapi-serializer').Deserializer;

export default function OmuniOrderConsignmentCard(props) {
  const [consignmentData, setConsignmentData] = useState({});

  useEffect(() => {
    try {
      new JSONAPIDeserializer({
        typeAsAttribute: false,
        pluralizeType: true,
        keyForAttribute: 'camelCase',
      })
        .deserialize(props.item)
        .then((data) => {
          setConsignmentData(data);
        });
    } catch (e) {}
  }, []);

  const { status, trackingUrl, placedOn, omuniOrderItems = [], id } = consignmentData || {};

  return (
    <>
      <ShopifyOrderItems
        orderItems={omuniOrderItems}
        createdAt={moment(placedOn).format('DD-MM-YYYY')}
        status={status}
        trackingUrl={trackingUrl}
        orderItemsHash={props.orderItems}
        orderName={id}
      />
    </>
  );
}
